import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import TechnoMist from "../../Assets/Projects/TechnoMist.png";
import ClinicData from "../../Assets/Projects/ClinicData.png";

import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import suicide from "../../Assets/Projects/suicide.png";


function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Mis recientes <strong className="purple">trabajos </strong>
        </h1>
        <p style={{ color: "white" }}>
          Proyectos que los que trabaje ultimamente:
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={TechnoMist}
              isBlog={false}
              title="TechnoMist"
              description="Esta aplicación ofrece una solución integral para la gestión de productos, carritos de compras y ventas en una plataforma de comercio electrónico. Permite listar productos de manera eficiente, gestionar el contenido de los carritos de compras y registrar las ventas, optimizando el proceso de compra y venta en línea."
              ghLink="https://github.com/Jonathan-Romano/TechnoMist-Back-End"
              demoLink="https://www.youtube.com/watch?v=O1oEGcQJSn0"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ClinicData}
              isBlog={false}
              title="ClinicData"
              description="Esta aplicación web permite gestionar de manera eficiente a los pacientes de un consultorio, junto con sus visitas médicas. Facilita la visualización y administración de la información de cada paciente, así como el registro detallado de las visitas realizadas, ofreciendo una herramienta integral para un manejo organizado y efectivo."
              ghLink="https://github.com/Jonathan-Romano/ClinicData-Back-End"
              demoLink="https://www.youtube.com/watch?v=bWbOO4wpbRc"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
